export default __webpack_public_path__ + "static/media/exit.ce78a1bd.svg";